import config from "src/config";
import { CodeResponseDto } from "src/dtos/code/codeDto";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/code`;

export const getCommonCodeList = async (params?: string) => {
	
  const url = `${baseUrl}/common` + (params ? `?${params}` : '');

  return await getData<ResponseDto<CodeResponseDto[]>>(url);
}

export const getMinorCodeList = async (majorCode: string) => {
	
	return await getData<ResponseDto<CodeResponseDto[]>>(baseUrl, {
		params: { majorCode }
	});
}

export const getConditionCodeList = async (majorCode: string) => {
	return await getData<ResponseDto<CodeResponseDto[]>>(`${baseUrl}/${majorCode}`);
}

export const getMajorCodeOptions = async () => {
	return await getData<ResponseDto<CodeResponseDto[]>>(`${baseUrl}/common`);
}